var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news_w" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "onlineTit" },
      _vm._l(_vm.navList, function (item, index) {
        return _c(
          "span",
          {
            key: index,
            staticClass: "change",
            class: { actClas: index === _vm.actNum },
            on: {
              click: function ($event) {
                return _vm.tabChange(index)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.actNum == 0
      ? _c("div", [
          _vm.antiEpidemicList.length > 0 ||
          _vm.sportsList.length > 0 ||
          _vm.footballList.length > 0 ||
          _vm.exerciseList.length > 0 ||
          _vm.collegeSportsList.length > 0 ||
          _vm.supplementaryList.length > 0
            ? _c("div", [
                _vm.antiEpidemicList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.antiEpidemicList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem listItem2",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.sportsList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.sportsList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.footballList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.footballList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem listItem3",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.exerciseList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.exerciseList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem listItem4",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.collegeSportsList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.collegeSportsList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem listItem5",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.supplementaryList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      _vm._l(_vm.supplementaryList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem listItem6",
                            on: {
                              click: function ($event) {
                                _vm.goTO(_vm.getCourseUrl(item))
                              },
                            },
                          },
                          [
                            _c("p", { staticClass: "courseName" }, [
                              _vm._v(_vm._s(item.courseName)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "school" }, [
                              _vm._v(_vm._s(item.fkCourseEmceeSchool)),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "line" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "foot" },
                              _vm._l(
                                _vm.getCourseInfo(item),
                                function (i, idx) {
                                  return _c(
                                    "div",
                                    { key: idx, staticClass: "card-foot" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.goTO(
                                                i.url || _vm.getCourseUrl(item)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-caret-right",
                                          }),
                                          _vm._v("第" + _vm._s(i.sort) + "讲"),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "paginationX" },
                  [
                    _vm.total > 0
                      ? _c("el-pagination", {
                          attrs: {
                            background: "",
                            "current-page": _vm.page.pageNum,
                            "page-size": _vm.page.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total,
                          },
                          on: {
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                {
                  staticStyle: { "margin-top": "50px", "text-align": "center" },
                },
                [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
              ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.actNum == 1
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
          },
          [
            _vm.commonList.length > 0
              ? _c(
                  "div",
                  { staticClass: "commonList" },
                  _vm._l(_vm.commonList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "commonListItem" },
                      [
                        _c("courseItemCommon", {
                          attrs: { type: 5, item: item },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "50px",
                      "text-align": "center",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginationX" },
              [
                _vm.totalNumber > 0
                  ? _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.page.pageNumber,
                        "page-size": _vm.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.totalNumber,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [_c("img")])
  },
]
render._withStripped = true

export { render, staticRenderFns }